/**
 * Body of the customer address card: the shared address form with the customer's wording, under
 * the note that these edits are not kept anywhere - the address is read from the order every time.
 */
import { observer } from "mobx-react";
import ListLayout, { LIST_LAYOUT_SPACING_VARIANT } from "../../../../../../../../components/layouts/list-layout/list-layout";
import { Note, NOTE_TYPE } from "../../../../../../../../components/note/note";
import ShipmentAddressForm from "../../../shared/shipment-address-form/shipment-address-form";
import { IValidateShippingDetailsProps } from "../validate-shipping-details-props";

const CustomerAddress: React.FC<IValidateShippingDetailsProps> = observer(({ store, validationGroup }) => (
    <ListLayout spacingVariant={LIST_LAYOUT_SPACING_VARIANT.SMAll}>
        <Note
            type={NOTE_TYPE.WARNING}
            caption="Customer information can't be stored in the system (GDPR restrictions)"
            body="Information is fetched in real time from the order. Changes made here won't be saved for future shipment retries."
        />

        <ShipmentAddressForm
            store={store.customerAddress}
            validationGroup={validationGroup}
            nameLabel="Customer name"
            showEmail
        />
    </ListLayout>
));

export default CustomerAddress;
